<a *ngIf="externalLink" [href]="linkRoute" target="_blank">
  <button
    [disabled]="disabled"
    class="linkButton"
    [ngbPopover]="popContent"
    container="body"
    triggers="{{ disabledPopoverText && disabled === true ? 'mouseenter:mouseleave' : null }}"
  >
    <h5 class="font-weight-300">{{ buttonText }}</h5>
    <img src="/assets/next-chevron.svg" alt="arrow icon" />
  </button>
</a>
<div
  [ngbPopover]="popContent"
  container="body"
  triggers="{{ disabledPopoverText && disabled === true ? 'mouseenter:mouseleave' : null }}"
>
  <button [disabled]="disabled" *ngIf="!externalLink" [routerLink]="linkRoute" class="linkButton">
    <h5 class="font-weight-300">{{ buttonText }}</h5>
    <img src="/assets/next-chevron.svg" alt="arrow icon" />
  </button>
</div>
<ng-template #popContent>
  <div [innerHtml]="disabledPopoverText"></div>
</ng-template>
